import { List } from 'immutable';
import { createSelector } from 'reselect';
import { isSnapshotLoaded } from './helpers';

const selectDomain = () => (state) => state.get('snapshotManagement');

const makeSelectDataLoading = () =>
  createSelector(selectDomain(), (substate) => substate.get('dataLoading'));
const makeSelectDeletingSnapshot = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('deletingSnapshot'),
  );
const makeSelectLoadingSnapshot = () =>
  createSelector(selectDomain(), (substate) => substate.get('loadingSnapshot'));
const makeSelectLockingSnapshot = () =>
  createSelector(selectDomain(), (substate) => substate.get('lockingSnapshot'));
const makeSelectCloningSnapshot = () =>
  createSelector(selectDomain(), (substate) => substate.get('cloningSnapshot'));
const makeSelectSavingName = () =>
  createSelector(selectDomain(), (substate) => substate.get('savingName'));
const makeSelectSavingNote = () =>
  createSelector(selectDomain(), (substate) => substate.get('savingNote'));
const makeSelectAllSnapshots = () =>
  createSelector(selectDomain(), (substate) => substate.get('snapshots'));
const makeSelectRefreshLoader = () =>
  createSelector(selectDomain(), (substate) => substate.get('refreshLoader'));
const makeSelectFetchDevicesLoader = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('fetchDevicesLoader'),
  );
const makeSelectAddLoader = () =>
  createSelector(selectDomain(), (substate) => substate.get('addLoader'));
const makeSelectCurrentSnapshot = () =>
  createSelector(selectDomain(), (substate) => {
    const snapshots = substate.get('snapshots');
    const selectedSnapshot = substate.get('selectedSnapshot');
    if (!selectedSnapshot) {
      return null;
    }
    return (
      snapshots.find((item) => item.get('id') === selectedSnapshot) || null
    );
  });
const makeSelectedSnapshot = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('selectedSnapshot'),
  );
const makeSelectLoadedSnapshots = () =>
  createSelector(makeSelectAllSnapshots(), (substate) =>
    substate.filter((item) => isSnapshotLoaded(item.get('state'))),
  );
const makeSelectUnloadingSnapshot = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('unloadingSnapshot'),
  );
const makeSelectUnlockingSnapshot = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('unlockingSnapshot'),
  );
const makeSelectUploadDialogueError = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('uploadDialogueError'),
  );
const makeSelectUploadingSnapshot = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('uploadingSnapshot'),
  );
const makeSelectDeleteDeviceSnapshotId = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('deleteDevicesSnapshotId'),
  );
const makeSelectSettingsLoading = () =>
  createSelector(selectDomain(), (substate) => substate.get('settingsLoading'));
const makeSelectLogsLoading = () =>
  createSelector(selectDomain(), (substate) => substate.get('logsLoading'));
const makeSelectInvalidPasswords = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('invalidPasswords'),
  );
const makeSelectSiteSeparation = () =>
  createSelector(selectDomain(), (substate) => substate.get('siteSeparation'));
const makeSelectDiscoveryTasks = () =>
  createSelector(selectDomain(), (substate) => substate.get('discoveryTasks'));
const makeSelectDisabledPostDiscoveryActions = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('disabledPostDiscoveryActions'),
  );

const makeSelectDisableStartBtn = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('disableStartButton'),
  );
const makeSelectMessagesTasker = () =>
  createSelector(selectDomain(), (substate) =>
    substate.getIn(['messages', 'tasker']),
  );
const makeSelectMessagesWorker = () =>
  createSelector(selectDomain(), (substate) =>
    substate.getIn(['messages', 'worker']),
  );
const makeSelectMessagesNetWorker = () =>
  createSelector(selectDomain(), (substate) =>
    substate.getIn(['messages', 'netWorker']),
  );
const makeSelectBandwidth = () =>
  createSelector(
    selectDomain(),
    (_state, props) => props.newSnapshot,
    (substate, newSnapshot) =>
      newSnapshot ? new List() : substate.get('bandwidth'),
  );
const makeSelectMaxbandwidth = () =>
  createSelector(selectDomain(), (substate) => substate.get('maxBandwidth'));
const makeSelectInProgressDevices = () =>
  createSelector(selectDomain(), (substate) =>
    substate
      .get('inProgressDevices')
      .map((val) => {
        return val
          .set('time', new Date(val.get('ts')).toLocaleString())
          .set('id', val.get('ip'));
      })
      .sort((a, b) => b.get('ts') - a.get('ts')),
  );
const makeSelectDevices = () =>
  createSelector(selectDomain(), (substate) => substate.get('devices'));

const makeSelectContentSnapshot = () =>
  createSelector(
    selectDomain(),
    (_state, props) => props.snapshotId,
    (substate, snapshotId) => {
      const snapshots = substate.get('snapshots');
      return snapshots.find((snapshot) => snapshot.get('id') === snapshotId);
    },
  );

const makeSelectDownloadingLogKeys = () =>
  createSelector(selectDomain(), (substate) =>
    substate.get('downloadingLogKeys'),
  );

export {
  makeSelectAddLoader,
  makeSelectAllSnapshots,
  makeSelectCloningSnapshot,
  makeSelectContentSnapshot,
  makeSelectCurrentSnapshot,
  makeSelectDataLoading,
  makeSelectDeleteDeviceSnapshotId,
  makeSelectDeletingSnapshot,
  makeSelectFetchDevicesLoader,
  makeSelectedSnapshot,
  makeSelectLoadedSnapshots,
  makeSelectLoadingSnapshot,
  makeSelectLockingSnapshot,
  makeSelectSavingName,
  makeSelectSavingNote,
  makeSelectUnloadingSnapshot,
  makeSelectUnlockingSnapshot,
  makeSelectUploadDialogueError,
  makeSelectUploadingSnapshot,
  makeSelectBandwidth,
  makeSelectDevices,
  makeSelectDisableStartBtn,
  makeSelectInProgressDevices,
  makeSelectMaxbandwidth,
  makeSelectMessagesNetWorker,
  makeSelectMessagesTasker,
  makeSelectMessagesWorker,
  makeSelectRefreshLoader,
  makeSelectSettingsLoading,
  makeSelectLogsLoading,
  makeSelectInvalidPasswords,
  makeSelectSiteSeparation,
  makeSelectDiscoveryTasks,
  makeSelectDownloadingLogKeys,
  makeSelectDisabledPostDiscoveryActions,
};
